import React from 'react';
import Header from './Header/Header';
import Menu from './Menu/Menu';

import './Layout.scss'

const Layout = props => {
  return (
    <>
      <Header />
      <div className="body-area">
        <Menu />
        <div className="menu-item-content">
					<div className="flex-1">{props.children}</div>
        </div>
      </div>
    </>
  );
};

export default Layout;
